// Common bundle — loaded on every page
// Vendor CSS
import '../css/vendor/bootstrap/bootstrap.min.css';
import '../css/vendor/bootstrap/bootstrap-theme.min.css';
import '../css/vendor/font-awesome/font-awesome.min.css';
import '../css/vendor/select2.css';

// Global styles (replaces @import chain from main-import.css)
import '../css/global/general.css';
import '../css/global/typography.css';
import '../css/global/forms.css';
import '../css/global/buttons.css';
import '../css/global/table.css';
import '../css/global/main-import.css';
import '../css/global/spacing.css';
import '../css/global/update.css';

// Layout-level JS — all scripts that were previously hardcoded as individual
// <script src> tags in alambil.phtml. Order matters: jQuery UI and Bootstrap
// must come before scripts that use their plugins (popover, tooltip, autocomplete).
import { runLegacy } from './helpers/load-legacy';
import jqueryUiJs          from '../js/vendor/jquery-ui.js?legacy';
import jqueryPlaceholderJs from '../js/vendor/jquery.placeholder.js?legacy';
import bootstrapJs         from '../js/vendor/bootstrap.min.js?legacy';
import select2Js           from '../js/vendor/select2.min.js?legacy';
import paginationJs        from '../js/global/pagination.js?legacy';
import homeControllerJs    from '../js/global/home-controller.js?legacy';
import readyEventsJs       from '../js/global/ready-events.js?legacy';
import productDetailsJs    from '../js/pages/catalog/product/product-details.js?legacy';
import yallJs              from '../js/global/yall.js?legacy';
import applicationJs       from '../js/global/application.js?legacy';
import updateJs            from '../js/global/update.js?legacy';
import analyticsJs         from '../js/global/analytics.js?legacy';
import searchJs            from '../js/global/search.js?legacy';

runLegacy(
    jqueryUiJs,
    jqueryPlaceholderJs,
    bootstrapJs,
    select2Js,
    paginationJs,
    homeControllerJs,
    readyEventsJs,
    productDetailsJs,
    yallJs,
    applicationJs,
    updateJs,
    analyticsJs,
    searchJs,
);
